import React from 'react'
import { checked, unChecked } from '../../../../assets/images'
import { handlePdfImages } from '../utils/common';

type AppProps = {
  singlePdf: { name: string, isChecked: boolean, id: string | number };
  handleChangeCheckBox: (index: number) => void;
  handleModal: (name?: string) => void;
  index: number;
  defaultPdfId: string | null;
  handleDefaultPdfId: (pdfId: string) => void;
}

const SinglePdfImage = ({ singlePdf, handleModal, handleChangeCheckBox, index, defaultPdfId, handleDefaultPdfId }: AppProps) => {



  return (
    <div className='image_container ' >

      <div
        className='pointer'
        onClick={() => handleChangeCheckBox(index)}
        style={{ position: "absolute", top: "10px", right: "10px" }}>
        {singlePdf?.isChecked ? (
          <img src={checked} alt="" />
        ) : (
          <img src={unChecked} alt="" />
        )}
      </div>

      <div className='image pointer' onClick={() => handleModal(singlePdf?.name)}>
        <img width={180} height={180} src={handlePdfImages(singlePdf?.name)} alt="Pdf Templates" />
      </div>

      <div className='image_bottom'>
        <p className='image_name'>{singlePdf?.name}</p>

        <p className={`default_name ${(singlePdf?.id == defaultPdfId && singlePdf?.isChecked) ? 'bg_green' : !singlePdf?.isChecked ? 'bg_disabled' : 'bg_white'}`} onClick={() => singlePdf?.isChecked ? handleDefaultPdfId(singlePdf?.id?.toString()) : null}>Mark This Default</p>
      </div>
    </div>
  )
}

export default SinglePdfImage
